import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const lineV = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: 0.12 * i } }),
};

export const MaskedLines = ({ lines, className = "", as = "h2", onLoad = false, baseDelay = 0, testid }) => {
  const Tag = motion[as];
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} data-testid={testid} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className="block will-change-transform" variants={lineV} custom={i + baseDelay}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p className={`eyebrow ${light ? "text-[#D8C7B5]" : "text-[#8C6A55]"}`}>{children}</p>
);
